import { getEnv, getPrimaryEnv, isProd } from 'utils/helpers';

const env = getEnv();

// Use getPrimaryEnv() which has smart environment detection with URL fallback
// This ensures correct URLs on Vercel deployments where NEXT_PUBLIC_ROOT_URL may not be set
export const rootUrl = getPrimaryEnv();
export const investUrl = `${env}investment.startengine.com`;
export const issuerUrl = `${env}issuer.startengine.com`;
export const accountUrl = `${env}account.startengine.com`;
export const marketplaceUrl = `${env}marketplace.startengine.com`;
export const secureUrl = `${env}secure.startengine.com`;
export const userUrl =
  process.env.NODE_ENV === 'development' ? 'http://localhost:8085' : `${env}user.startengine.com`;
export const secondaryUrl = `${env}secondary.startengine.com`;

export const userMenu = {
  referralProgram: `${rootUrl}/referral-program/${isProd ? 'StartEngineOWN' : 'program-a1'}`,
  dashboard: `${investUrl}`,
  issuer: `${issuerUrl}/`,
  onboarding: `${getPrimaryEnv()}/onboarding`,
  login: `${userUrl}?redirect=${rootUrl}`,
  logout: `${userUrl}/signout?redirect=${rootUrl}`,
  signup: `${userUrl}?section=signup&redirect=${rootUrl}`,
  scout: `${rootUrl}/scout?isource=nav-bar`,
  ventureClub: `${rootUrl}/venture-club`,
  ownersBonus: `${rootUrl}/owners-bonus`,
  settings: `${accountUrl}/settings`,
  home: `${rootUrl}/explore`,
  marketplacePromo: `${rootUrl}/marketplace`,
  marketplace: `${marketplaceUrl}`,
  myTrades: `${secondaryUrl}`,
  success: '/success-stories',
  portfolio: `${investUrl}/account/portfolio`,
  secure: `${secureUrl}`,
  iraTransfer: `${investUrl}/account/ira-funding/investment-account/ira-transfer-in`,
  equityTrust: `${rootUrl}/equity-trust`,
};

export const topNavMenu = {
  startInvesting: `${rootUrl}/explore`,
  learn: `${rootUrl}/explore`,
  getFunding: `${rootUrl}/raise-capital`,
  ventureClubInfo: `${rootUrl}/venture-club`,
  ownersBonusInfo: `${rootUrl}/owners-bonus`,
  collectibles: `${rootUrl}/collectibles`,
  howInvestingWorks: `${rootUrl}/how-investing-works`,
  investorFaq: `${rootUrl}/investor-faq`,
  iosApp: 'https://startengine.onelink.me/4ni7/6g7c1cf5',
};

export const footerMenu = {
  about: `${rootUrl}/about`,
  blog: `${rootUrl}/blog`,
  crowdfunding: `${rootUrl}/equity-crowdfunding`,
  careers: `${rootUrl}/careers`,
  portfolioJob: 'https://startengine.getro.com/',
  raiseCapital: `${rootUrl}/raise-capital`,
  faqs: `${rootUrl}/company-faqs`,
  why: `${rootUrl}/why-startengine`,
  partnerships: `${rootUrl}/partnerships`,
  contact: `${rootUrl}/contact`,
  help: 'https://help.startengine.com/',
  terms: `${rootUrl}/terms`,
  privacy: `${rootUrl}/privacy`,
  disclaimer: `${rootUrl}/disclaimer`,
  reports: `${rootUrl}/annual-reports`,
  formCrs: `${rootUrl}/form-crs`,
};

export const homeMenu = {
  regulationCrowdfunding: `${rootUrl}/blog/regulation-crowdfunding-101-for-entrepreneurs/`,
  regulationA: `${rootUrl}/blog/regulation-a-what-entrepreneurs-need-to-know/`,
};

export const socialMenu = {
  facebook: 'https://www.facebook.com/StartEngineLA/',
  twitter: 'https://x.com/startenginela',
  linkedIn: 'https://www.linkedin.com/company/3815484/',
  instagram: 'https://www.instagram.com/startenginela',
};
